const aodErrors = {

    // general errors
    UNKNOWN_FAILURE: -1,
    MISSING_REQUIRED_DATA: -2,
    INVALID_REQUIRED_DATA: -3,
    OPTIMISTIC_LOCK_FAILURE: -4,
    RECORD_VERSION_MISMATCH: -5,
    MIAD_LOGIN_FAILURE: -6,
    MIAD_COMMAND_FAILURE: -7,
    EXTERNAL_COMMAND_FAILURE: -8,
    TRIAL_QUOTA_EXCEEDED: -9,
    TRIAL_EXPIRED: -10,
    CONFIGURATION_ISSUE: -11,
    // TODO - decide if we should combine NOT_AUTHORIZED and USER_PRIVILEGE_ISSUE - or should we change the name of NOT_AUTHORIZED and use that here?
    USER_PRIVILEGE_ISSUE: -12,
    ATTEMPTING_TO_CHANGE_IMMUTABLE: -13,

    // Object not found
    ACCOUNT_NOT_FOUND: -20,
    ADVERTISER_NOT_FOUND: -21,
    PERSON_NOT_FOUND: -22,
    LOGIN_NOT_FOUND: -23,
    MASTER_NOT_FOUND: -24,
    DOCUMENT_NOT_FOUND: -25,
    SALES_SHEET_NOT_FOUND: -26,
    SPEC_AD_NOT_FOUND: -27,
    COUNTRY_NOT_FOUND: -28,
    PERSON_OWNER_NOT_FOUND: -29,
    MANAGED_FILE_NOT_FOUND: -30,
    FILE_VERSION_NOT_FOUND: -31,
    STORE_FILE_NOT_FOUND: -32,
    MANAGED_FILE_OWNER_NOT_FOUND: -33,
    CACHED_FILE_NOT_FOUND: -34,
    ROLE_TARGET_NOT_FOUND: -35,
    TRIAL_NOT_FOUND: -36,
    PROJECT_NOT_FOUND: -37,
    PROJECT_ITEM_NOT_FOUND: -38,
    PREFERENCE_NOT_FOUND: -39,
    HISTORY_TARGET_NOT_FOUND: -40,
    PUBLICATION_NOT_FOUND: -41,
    AD_TYPE_NOT_FOUND: -42,
    AD_KIND_NOT_FOUND: -43,
    AD_FORMAT_NOT_FOUND: -44,
    AD_SIZE_NOT_FOUND: -45,
    AD_COLOR_NOT_FOUND: -46,
    ORDER_NOT_FOUND: -59,

    // resource specific errors

    // Publication
    PUBLICATION_ALREADY_EXISTS: -60,

    // Order
    ORDER_ALREADY_EXISTS: -70,

    // BsResource
    BS_ERRORS_OCCURRED: -100,

    // PreferenceResource
    PREFERENCE_NAME_INVALID: -110,
    PREFERENCE_SET_FAILED: -118,
    PREFERENCE_REMOVE_FAILED: -119,

    // EmailResource
    EMAIL_CONTAINS_BAD_ADDRESS: -140,
    EMAIL_CONTAINS_BAD_ATTACHMENT: -141,
    EMAIL_SEND_FAILURE: -142,

    // PersonResource
    PERSON_ALREADY_EXISTS: -150,
    LOGIN_ALREADY_EXISTS: -151,

    // ManagedFileResource
    MANAGED_FILE_UPLOAD_FAILED: -160,
    MANAGED_FILE_ATTACH_ARTWORK_FAILED: -161,
    MANAGED_FILE_PICKUP_FAILED: -162,

    // AdvertiserResource
    ADVERTISER_ALREADY_EXISTS: -170,

    // AccountResource
    ACCOUNT_ALREADY_EXISTS: -180,
    ACCOUNT_CREATE_FAILED: -181,

    // ReportResource
    REPORT_FAILED_TO_TRANSFORM_TEMPLATE: -190,
    REPORT_TEMPLATE_NOT_FOUND: -191,
    REPORT_TEMPLATE_NOT_READABLE: -192,

    // Authentication Errors
    NOT_LOGGED_IN: -200,
    LOGIN_INVALID: -201,
    SYSTEM_CLOSED: -202,
    NOT_AUTHORIZED: -203,
    TRIAL_SETUP_FAILED: -204,
    UPGRADE_REQUIRED: -205,
    REGISTRATION_REQUIRED: -206,
    REGISTRATION_FAILED: -207,
    LOGIN_NOT_ACTIVATED: -208,
    ACTIVATION_REQUIRED: -209,
    MISSING_REGISTRATION_TOKEN: -210,
    INVALID_REGISTRATION_TOKEN: -211,
    EXPIRED_REGISTRATION_TOKEN: -212
};

export default aodErrors;